module.exports = __webpack_public_path__ + "img/cotoclub6.9693cb31.png";